import React, { useState, useEffect, useCallback } from 'react';
import axios from "axios";
import { Grid } from "@material-ui/core";
import GeneralModal from "../../../../Components/Modals/CustomModal";
import CloseFields from "./CloseFields";
import LoadPvImage from "./LoadPvModal";
import ObservationField from "./ObservationField";
import BillFields from '../../../Tasks/Modals/billFields';

import * as lang from "../../../../Constants/strings";
import * as requestHeaders from "../../../../Constants/requestHeaders";

import { bindActionCreators } from "redux";
import  * as actionCreators from "../../../../actions/actions";
import { connect } from "react-redux";

const ActionModal = (props) => {
	const {
		open,
		close,
		execute,
		installation,
		loadPvImage = false,
		language,
		refetchTaskData,
		userId,
		onNotificationOpen
	} = props;

	useEffect(() => {
		if (props.installation)
			setNextStatusId(getNextStatusId(props.installation.STATUS_ID));
	}, [props.installation]);

	const [nextStatusId, setNextStatusId] = useState(2);
	const [observation, setObservation] = useState("");
	const [noBill, setNoBill] = useState(true);

	useCallback(() => {
		checkForBill();
	}, []);

	const checkForBill = async () => {
		try {
			const { data: { data } } = await axios.get('/api/installation_bill_count', {
				...requestHeaders.getGetHeader(),
				params: {
					id: props.installation ? props.installation.OBJID : ""
				}
			})
			setNoBill(!(data > 0));
		} catch (error) {
			setNoBill(true);
			console.log("The installation doesn't have a bill!")
		}
	}

	useEffect(() => {
		checkForBill();
	}, [props.installation]);

	const getNextStatusId = (status) => {
		switch (status) {
			case 1:
			case 4:
				return 2;
			case 2:
			case 3:
				return 5;
			case 5:
				return 6;
			case 6:
				return 8;
			default:
				return null;
		}
	};

	const getNextStatus = (status) => {
		switch (status) {
			case 1:
			case 4:
				return "OPEN";
			case 2:
			case 3:
				return "ON_DRIVE";
			case 5:
				return "STARTED";
			case 6:
				return "CLOSED";
			default:
				return "CLOSED";
		}
	};

	const nextStep = async () => {
		let data = {
			installationId: installation.OBJID,
			note: observation,
			userId: userId,
			geolocation: props.geolocation
		};

		console.log(data)
		try {
			await axios.post("/api/installation_next_step", data, requestHeaders.getPostHeader());
			refetchTaskData();
			setObservation("");
			onNotificationOpen("success", "DATA_UPDATE_SUCCESS");
		} catch (error) {
			console.error(error);
			onNotificationOpen("error", "ERROR_OCCURED");
		}
	}

	const doAction = () => {
		switch (nextStatusId) {
			case 8:
				close();
				break;
			default: {
				nextStep();
				close();
			}
		}
	}

	return (
		<GeneralModal
			open={open}
			close={close}
			fullWidth
			title={
				props.installation && props.installation.STATUS_ID ?
					lang[getNextStatus(props.installation.STATUS_ID)][language] :
					""
			}
			language={language}
			content={
				<Grid container spacing={2}>
					{
						nextStatusId !== 8 &&
						<ObservationField
							language={language}
							note={observation}
							updateNote={setObservation}
						/>
					}
					{
						nextStatusId === 8 && !noBill && !loadPvImage &&
						<CloseFields
							installationId={props.installation ? props.installation.OBJID : ""}
							language={language}
							userId={userId}
							refetchTaskData={() => {
								refetchTaskData();
								close();
							}}
							nextStatus={getNextStatusId(props.installation.STATUS_ID)}
							currentStatus={props.installation.STATUS_ID}
						/>
					}
					{nextStatusId === 8 && !loadPvImage && noBill &&
						<BillFields
							userId={userId}
							taskId={props.installation ? props.installation.OBJID : ""}
							language={language}
							onNotificationOpen={(type, data) => {
								refetchTaskData();
								onNotificationOpen(type, data);
							}}
						/>
					}
					{
						nextStatusId === 8 && loadPvImage &&
						<LoadPvImage />
					}
				</Grid>
			}
			execute={doAction}
			formValidate={nextStatusId !== 8}
		/>
	)
};

const mapStateToProps = (state) => ({
	geolocation: state.config.geolocation
})

const mapDispatchToProps = (dispatch) => ({
	actions: bindActionCreators(actionCreators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ActionModal);